import React, { useContext, useState } from "react"
import { Button, Col, Form, Modal, Offcanvas, Row } from "react-bootstrap"
import {
  MdArrowDropDown,
  MdArrowDropUp,
  MdArrowLeft,
  MdArrowRight,
  MdDeleteOutline,
} from "react-icons/md"
import { UsuarioContext } from "../Context/Usuario"
import log from "loglevel"
import columnsPostulantes from "../ReporteMatriculas/ColumnasReporte"

/**
 *
 * @returns
 */
const FiltrosTabs = (props) => {
  const { usuario } = useContext(UsuarioContext)

  const [
    showAddCoordinadoraAdmision,
    setShowAddCoordinadoraAdmision,
  ] = useState(false)
  const [
    showAddCoordinadoraPrograma,
    setShowAddCoordinadoraPrograma,
  ] = useState(false)
  const [showFiltroFechaInicio, setShowFiltroFechaInicio] = useState(false)

  const [selectedColumnAdd, setSelectedColumnAdd] = useState(null)
  const [selectedColumnDelete, setSelectedColumnDelete] = useState(null)
  const [fechaInicioDesde, setFechaInicioDesde] = useState(new Date(usuario.periodo, 0, 1))
  const [fechaInicioHasta, setFechaInicioHasta] = useState(new Date(usuario.periodo, 11, 31))

  const columns =
    props.tipoColumnas === "cohortes"
      ? Object.values(usuario.atributos).reduce((prev, current) => {
          if (!current.visible || !current.Codigo || !current.Nombre) {
            return prev
          }
          prev.push({ key: current.Codigo, title: current.Nombre })
          return prev
        }, [])
      : Object.values(columnsPostulantes).reduce((prev, current) => {
          prev.push({ key: current.key, title: current.title })
          return prev
        }, [])

  let visibleColumns =
    props.columns && props.columns[props.index]
      ? props.columns[props.index].reduce((prev, current) => {
          let column = columns.find((c) => c.key === current)
          if (column) {
            prev.push({
              key: current,
              title: column.title,
            })
          } else {
            log.debug(props)
            log.warn("Columna inválida! " + current)
            prev.push({
              key: current,
              title: "???",
            })
          }
          return prev
        }, [])
      : []

  return (
    <Offcanvas
    className="filtrosTabsOffcanvas"
      show={props.showFilterOffcanvas}
      placement="end"
      onHide={() => {
        if (props.setShowFilterOffcanvas) {
          props.setShowFilterOffcanvas(false)
        }
      }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Configuración de vista {props.index}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <h5>Filtrar por</h5>
        <div
          className="filtroAplicado"
          onClick={() => {
            setShowAddCoordinadoraAdmision(!showAddCoordinadoraAdmision)
          }}
        >
          <span className="filtroNombre">Coordinador/a admisión:</span>
          <br />
          <span className="filtroValor">
            {props.activeFilters &&
              props.activeFilters[props.index] &&
              props.activeFilters[props.index].coordinadorasadmision &&
              props.activeFilters[props.index].coordinadorasadmision.length >
                0 && (
                <ul>
                  {props.activeFilters[props.index].coordinadorasadmision.map(
                    (c) => (
                      <li key={c}>
                        {usuario.coordinadorasadmision[c].nombre}
                        <MdDeleteOutline
                          className="filtroDelete"
                          onClick={(e) => {
                            e.stopPropagation()
                            props.deleteFilterCoordinadoraAdmision(c)
                          }}
                        />
                      </li>
                    )
                  )}
                </ul>
              )}
            {(!props.activeFilters ||
              !props.activeFilters[props.index] ||
              !props.activeFilters[props.index].coordinadorasadmision ||
              props.activeFilters[props.index].coordinadorasadmision.length ===
                0) && <>Todas</>}
          </span>
        </div>
              <Modal show={showAddCoordinadoraAdmision} onHide={()=>{setShowAddCoordinadoraAdmision(false)}}>
        <Modal.Header closeButton>
          <Modal.Title>Filtrar por coordinador/a de admisión</Modal.Title>
        </Modal.Header>
        <Modal.Body>        <div
          className={"filtroTabs"}
          style={{
            display: showAddCoordinadoraAdmision ? "" : "none",
          }}
        >
          <Form.Select
            onChange={(e) => {
              if (!e.target.value) {
                window.alert("Debe escoger una coordinadora")
              } else {
                props.addFilterCoordinadoraAdmision(e.target.value)
              }
            }}
          >
            <option value="">Seleccione</option>
            {Object.values(usuario.coordinadorasadmision)
              .filter((v) => {
                let intersection = v.cohortes[usuario.periodo]
                  ? v.cohortes[usuario.periodo].filter(
                      (x) =>
                        props.cohortesusuario &&
                        props.cohortesusuario.includes(x)
                    )
                  : []
                return (
                  v.key !== "" &&
                  v.nombre !== "" &&
                  intersection.length > 0 &&
                  (!props.activeFilters ||
                    !props.activeFilters[props.index] ||
                    !props.activeFilters[props.index].coordinadorasadmision ||
                    props.activeFilters[
                      props.index
                    ].coordinadorasadmision.indexOf(v.key) < 0)
                )
              })
              .map((v) => (
                <option value={v.key} key={v.key}>
                  {v.nombre}
                </option>
              ))}
          </Form.Select>
        </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setShowAddCoordinadoraAdmision(false)
            }}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

        <div
          className="filtroAplicado"
          onClick={() => {
            setShowAddCoordinadoraPrograma(true)
          }}
        >
          <span className="filtroNombre">Coordinador/a de programa:</span>
          <br />
          <span className="filtroValor">
            {props.activeFilters &&
              props.activeFilters[props.index] &&
              props.activeFilters[props.index].coordinadorasprogramas &&
              props.activeFilters[props.index].coordinadorasprogramas.length >
                0 && (
                <ul>
                  {props.activeFilters[props.index].coordinadorasprogramas.map(
                    (c) => (
                      <li key={c}>
                        {usuario.coordinadorasprogramas[c].nombre}
                        <MdDeleteOutline
                          className="filtroDelete"
                          onClick={(e) => {
                            e.stopPropagation()
                            props.deleteFilterCoordinadoraPrograma(c)
                          }}
                        />
                      </li>
                    )
                  )}
                </ul>
              )}
            {(!props.activeFilters ||
              !props.activeFilters[props.index] ||
              !props.activeFilters[props.index].coordinadorasprogramas ||
              props.activeFilters[props.index].coordinadorasprogramas.length ===
                0) && <>Todas</>}
          </span>
        </div>
              <Modal show={showAddCoordinadoraPrograma} onHide={() => {setShowAddCoordinadoraPrograma(false)}}>
        <Modal.Header closeButton>
          <Modal.Title>Filtrar por coordinador/a de programa</Modal.Title>
        </Modal.Header>
        <Modal.Body>        <div
          className={"filtroTabs"}
          style={{
            display: showAddCoordinadoraPrograma ? "" : "none",
          }}
        >
          <Form.Select
            onChange={(e) => {
              if (!e.target.value) {
                window.alert("Debe escoger una coordinadora")
              } else {
                props.addFilterCoordinadoraPrograma(e.target.value)
              }
            }}
          >
            <option value="">Seleccione</option>
            {Object.values(usuario.coordinadorasprogramas)
              .filter((v) => {
                let intersection = v.cohortes[usuario.periodo]
                  ? v.cohortes[usuario.periodo].filter(
                      (x) =>
                        props.cohortesusuario &&
                        props.cohortesusuario.includes(x)
                    )
                  : []
                return (
                  v.key !== "" &&
                  v.nombre !== "" &&
                  intersection.length > 0 &&
                  (!props.activeFilters ||
                    !props.activeFilters[props.index] ||
                    !props.activeFilters[props.index].coordinadorasprogramas ||
                    props.activeFilters[
                      props.index
                    ].coordinadorasprogramas.indexOf(v.key) < 0)
                )
              })
              .map((v) => (
                <option value={v.key} key={v.key}>
                  {v.nombre}
                </option>
              ))}
          </Form.Select>
        </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setShowAddCoordinadoraPrograma(false)
            }}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

        <div
          className="filtroAplicado"
          onClick={() => {
            setShowFiltroFechaInicio(!showFiltroFechaInicio)
          }}
        >
          <span className="filtroNombre">Fecha de inicio:</span>
          <br />
          <span className="filtroValor">
            {props.activeFilters &&
              props.activeFilters[props.index] &&
              props.activeFilters[props.index].fechainicio &&
              props.activeFilters[props.index].fechainicio.start &&
              props.activeFilters[props.index].fechainicio.end && (
                <>Desde: {props.activeFilters[props.index].fechainicio.start.toLocaleDateString('es-CL')} hasta: {props.activeFilters[props.index].fechainicio.end.toLocaleDateString('es-CL')}                        <MdDeleteOutline
                          className="filtroDelete"
                          onClick={(e) => {
                            e.stopPropagation()
                            props.deleteFilterFechaInicio()
                          }}
                        />
</>
              )}
            {(!props.activeFilters ||
              !props.activeFilters[props.index] ||
              !props.activeFilters[props.index].fechainicio) && <>Todo {usuario.periodo}</>}
          </span>
        </div>
        <Modal show={showFiltroFechaInicio} onHide={() => {setShowFiltroFechaInicio(false)}}>
        <Modal.Header closeButton>
          <Modal.Title>Filtrar por fecha de inicio</Modal.Title>
        </Modal.Header>
        <Modal.Body>                <div
          className={"filtroTabs"}
          style={{
            display: showFiltroFechaInicio ? "" : "none",
          }}
        >
          <Form style={{width:"100%"}}>
            <Row>
              <Col xs={6}>
            <Form.Label htmlFor="disabledSelect">Desde</Form.Label>
            <Form.Control id="datefrom" type="date" onChange={(e) => {
              setFechaInicioDesde(new Date(Date.parse(e.target.value)))
            }} defaultValue={fechaInicioDesde.toISOString().split('T')[0]}/>
              </Col>
              <Col xs={6}>
            <Form.Label htmlFor="disabledSelect">Hasta</Form.Label>
            <Form.Control id="dateto" type="date" onChange={(e) => {
              setFechaInicioHasta(new Date(Date.parse(e.target.value)))
            }} defaultValue={fechaInicioHasta.toISOString().split('T')[0]}/>
            </Col>
            </Row>
          </Form>
        </div>
</Modal.Body>
        <Modal.Footer>
                      <Button
            onClick={() => {
              log.debug("Cambiando fechas")
              log.debug(fechaInicioDesde)
              log.debug(fechaInicioHasta)
              props.setFiltroFechaInicio(fechaInicioDesde, fechaInicioHasta)
              setShowFiltroFechaInicio(false)
            }}
          >
            Guardar
          </Button>
                      <Button
                      variant="secondary"
                      style={{marginLeft:"1rem"}}
            onClick={() => {
              setShowFiltroFechaInicio(false)
            }}
          >
            Cancelar
          </Button>
        </Modal.Footer>
        </Modal>
        <h5>Agrupar por</h5>
        <Form.Select
          onChange={(e) => {
            if (!e.target.value) {
              window.alert("Debe escoger una agrupación")
            } else {
              log.debug("Cambiando agrupar a " + e.target.value)
              props.changeGroupBy(e.target.value)
            }
          }}
          defaultValue={props.groupby}
        >
          <option value="">Seleccione</option>
          <option value="usuario_coordinador_admision">
            Coordinadora de Admisión
          </option>
          <option value="grupo_reporte_matriculados">Grupo de reporte</option>
          <option value="facultades">Facultades / Escuelas</option>
        </Form.Select>
        <br />
        <h5>Columnas visibles</h5>
        <Row>
          <Col xs={5}>
            <p>Disponibles</p>
            <Form.Select
              htmlSize={10}
              onChange={(e) => {
                setSelectedColumnAdd(e.target.value)
              }}
              defaultValue={selectedColumnAdd}
            >
              {columns
                .filter(
                  (c) =>
                    (!c.filtro || c.filtro(usuario, null) === true) &&
                    props.columns &&
                    props.columns[props.index] &&
                    props.columns[props.index].indexOf(c.key) < 0
                )
                .sort((a, b) => {
                  if (!a || !b || !a.title || !b.title) {
                    log.debug(columns)
                    log.debug(props.index)
                    log.debug(props.columns[props.index])
                    log.debug(a)
                    log.debug(b)
                    throw new Error("Columnas inválidas!")
                  }
                  return a.title.localeCompare(b.title)
                })
                .map((column) => {
                  return (
                    <option key={column.key} id={column.key} value={column.key}>
                      {column.title}
                    </option>
                  )
                })}
            </Form.Select>
          </Col>
          <Col xs={1} className="col-arrowButtons">
            <MdArrowLeft
              className="arrowButtons"
              role="button"
              onClick={() => {
                if (!selectedColumnDelete) {
                  return
                }
                log.debug("Eliminaremos la columna " + selectedColumnDelete)
                props.deleteColumn(selectedColumnDelete)
                setSelectedColumnDelete(null)
              }}
            />
            <br />
            <br />
            <MdArrowRight
              className="arrowButtons"
              role="button"
              onClick={() => {
                if (!selectedColumnAdd) {
                  return
                }
                log.debug("Agrearemos la columna " + selectedColumnAdd)
                props.addColumn(selectedColumnAdd)
                setSelectedColumnAdd(null)
              }}
            />
          </Col>
          <Col xs={5}>
            <p>Visibles</p>
            <Form.Select
              htmlSize={10}
              onChange={(e) => {
                setSelectedColumnDelete(e.target.value)
              }}
              defaultValue={selectedColumnDelete}
            >
              {visibleColumns.map((column) => {
                return (
                  <option key={column.key} id={column.key} value={column.key}>
                    {column.title}
                  </option>
                )
              })}
            </Form.Select>
          </Col>
          <Col xs={1} className="col-arrowButtons">
            <MdArrowDropUp
              className="arrowButtons"
              role="button"
              onClick={() => {
                if (!selectedColumnDelete) {
                  return
                }
                props.moveColumnUp(selectedColumnDelete)
              }}
            />
            <br />
            <br />
            <MdArrowDropDown
              className="arrowButtons"
              role="button"
              onClick={() => {
                if (!selectedColumnDelete) {
                  return
                }
                props.moveColumnDown(selectedColumnDelete)
              }}
            />
          </Col>
        </Row>
      </Offcanvas.Body>
    </Offcanvas>
  )
}

export default FiltrosTabs
